export class ClientNote {
}
//# sourceMappingURL=clientNote.js.map